/**
 * Utility functions for the configurator components
 */

/**
 * Decode HTML entities in a string
 * @param {string} str - The string to decode
 * @returns {string} Decoded string
 */
export function decodeHtml(str = '') {
  const txt = document.createElement('textarea');
  txt.innerHTML = str;
  return txt.value;
}

/**
 * Check if an item has a valid image
 * @param {Object} item - The item to check
 * @returns {boolean} True if item has a valid image
 */
export function hasImage(item) {
  return !!(item?.imageUrl || item?.image);
}

/**
 * Get the image URL from an item
 * @param {Object} item - The item to get image from
 * @returns {string} Image URL or empty string
 */
export function getImageUrl(item) {
  return item?.imageUrl || item?.image || '';
}

/**
 * Get the display name from an item
 * @param {Object} item - The item to get name from
 * @returns {string} Display name
 */
export function getDisplayName(item) {
  return item?.name || item?.title || '';
}

/**
 * Get the display image from package data
 * @param {Object} packageData - The full package data to get name from
 * @returns {Object} Full image
 */
export function getPackageDataImage(packageData) {
  if (packageData?.isBasePackage && packageData?.basePackage?.image) {
    return {
      medium: packageData.basePackage.image,
      src: packageData.basePackage.image,
    };
  }

  const pkgImg =
    packageData?.packaging?.images?.[0] ||
    packageData?.package?.images?.[0] ||
    packageData?.packagingProduct?.image;

  if (pkgImg) {
    return pkgImg;
  }

  if (packageData?.basePackage?.images?.[0]) {
    return packageData.basePackage.images[0];
  }
  return (
    packageData?.products?.[0]?.images?.[0] ||
    packageData?.foodDrinks?.[0]?.images?.[0]
  );
}
